var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC4A38",
    d: "M23.152.02H.783A.744.744 0 00.04.766V22.6a.745.745 0 00.744.745h22.37a.744.744 0 00.744-.745V.765a.744.744 0 00-.745-.744z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.563 12.82l-.753-.584c-.229-.19-.542-.44-.542-.9 0-.461.313-.755.585-1.026.877-.69 1.753-1.425 1.753-2.973 0-1.592-1.001-2.429-1.481-2.826h1.294l1.358-.854h-4.115c-1.13 0-2.757.267-3.949 1.251-.898.775-1.336 1.843-1.336 2.805C5.377 9.345 6.631 11 8.844 11c.21 0 .438-.02.668-.042-.103.252-.208.461-.208.817 0 .648.333 1.046.627 1.422-.94.065-2.696.17-3.99.965-1.233.733-1.608 1.8-1.608 2.553 0 1.55 1.46 2.994 4.49 2.994 3.593 0 5.494-1.988 5.494-3.956 0-1.446-.835-2.157-1.754-2.932zm-2.736-2.406c-1.797 0-2.611-2.323-2.611-3.725 0-.546.103-1.11.459-1.55.335-.419.918-.69 1.463-.69 1.732 0 2.631 2.343 2.631 3.851 0 .377-.042 1.046-.522 1.529a2.136 2.136 0 01-1.42.585zm.02 8.417c-2.234 0-3.676-1.069-3.676-2.555 0-1.486 1.337-1.989 1.796-2.155.877-.295 2.006-.336 2.194-.336.209 0 .313 0 .48.02 1.588 1.131 2.278 1.695 2.278 2.765 0 1.296-1.066 2.261-3.072 2.261zm7.991-8.449V8.289h-1.034v2.093h-2.09v1.045h2.09v2.106h1.034v-2.106h2.1v-1.045h-2.1z"
  }))));
}

export default SvgGoogle;